import { render, staticRenderFns } from "./RestsDatatable.vue?vue&type=template&id=6d69e1d4"
import script from "./RestsDatatable.vue?vue&type=script&lang=js"
export * from "./RestsDatatable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports